/** 将组件贴回画布内：只改 left/top，不缩放。组件比画布大时贴到 0,0。 */

export function isMainCanvasPage(pageArr) {
  if (!Array.isArray(pageArr) || !pageArr.length) {
    return true;
  }
  const back =
    pageArr.find((c) => c && c.id === "Back") || pageArr[0];
  return !(back && back.isChildPage);
}

export function clampComponentsToCanvas(list, canvasW, canvasH) {
  if (!Array.isArray(list)) {
    return false;
  }
  const wMax = Number(canvasW);
  const hMax = Number(canvasH);
  if (!isFinite(wMax) || !isFinite(hMax) || wMax <= 0 || hMax <= 0) {
    return false;
  }
  let changed = false;
  for (let i = 0; i < list.length; i++) {
    const comp = list[i];
    if (!comp || comp.id === "Back" || comp.component === "Back") {
      continue;
    }
    const st = comp.style;
    if (!st || typeof st !== "object") {
      continue;
    }
    const cw = Number(st.width) || 0;
    const ch = Number(st.height) || 0;
    const left = Number(st.left) || 0;
    const top = Number(st.top) || 0;
    const nextLeft = Math.min(Math.max(0, left), Math.max(0, wMax - cw));
    const nextTop = Math.min(Math.max(0, top), Math.max(0, hMax - ch));
    if (nextLeft !== left) {
      st.left = nextLeft;
      changed = true;
    }
    if (nextTop !== top) {
      st.top = nextTop;
      changed = true;
    }
  }
  return changed;
}
